module.exports = __webpack_public_path__ + "e9c477e8/img/lock-icon.bb9c7166.svg";